import { render, staticRenderFns } from "./OrganizationRegisterForm.vue?vue&type=template&id=649c2d92&"
import script from "./OrganizationRegisterForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports